export namespace SellNow {
    export class UpdateForm {
        static readonly type = '[Sell now] update form';
        constructor(public payload: any) {}
    }

    export class UpdateIntro {
        static readonly type = '[Sell now] update form introl status';
        constructor(public payload: boolean) {}
    }
}
